import { useEffect } from 'react'
import {Outlet} from 'react-router-dom'
import {useLocation} from 'react-router-dom'

import {AsideDefault} from './components/aside/AsideDefault'
import {Content} from './components/Content'
import {DrawerMessenger } from '../partials'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {MenuComponent} from '../assets/ts/components'
import {PageDataProvider} from './core'
import {ScrollTop} from './components/ScrollTop'

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />
          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
        </div>
      </div>
      <DrawerMessenger />
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
